import { deleteRequest, getRequest, patchRequest, postRequest } from 'services/requests';

const services = {
    createAccount: (id, body) => postRequest(`/accounts/${id}`, body),
    findAccount: (id) => getRequest(`/accounts/${id}`),
    updateAccount: (id, body) => patchRequest(`/accounts/${id}`, body),
    deleteAccount: (id) => deleteRequest(`/accounts/${id}`),
    getAccountTokens: (id) => getRequest(`/accounts/${id}/tokens`),
};

export default services;
